/**
 * 일반자료실 목록 페이지 컴포넌트
 * API에서 자료실 데이터를 가져와 ItemList 컴포넌트로 목록 형태로 표시합니다.
 */

import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import SubPage from '../template/SubPage';
import ItemList from '../components/ItemList';
import useAsync from '../hooks/useAsync';
import { getDatas } from '../Api';
import { Sort } from '../utils/Sort';
import { MENU_DATA } from '../constant/menuData';
import MyHelmet from '../hooks/Helmet';

// 한 번에 가져올 게시물 수
const LIMIT = 6;

function DataPage() {
  const [order, setOrder] = useState('createdAt');
  const [isLoading, loadingError, getNoticessAsync] = useAsync(getDatas);
  const [items, setItems] = useState([]);

  // ID 기준 내림차순 정렬 후 Sort 유틸리티로 추가 처리
  const sortedItems = Sort(items.sort((a, b) => b['id'] - a['id']));

  // 메뉴 데이터 가져오기
  const menuData = MENU_DATA.community;

  /**
   * 자료실 데이터를 로드하는 핸들러
   */
  const handleLoad = useCallback(
    async (options) => {
      const result = await getNoticessAsync(options);
      if (!result) return;

      const datas = result;
      if (options.offset === 0) {
        setItems(datas);
      } else {
        setItems((prevItems) => [...prevItems, ...datas]);
      }
      setOrder('createdAt');
    },
    [getNoticessAsync]
  );

  useEffect(() => {
    handleLoad({ order, offset: 0, limit: LIMIT });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <MyHelmet />
      <SubPage
        title={menuData.label}
        description={menuData.description}
        menuItems={menuData.subMenus}
        currentNo="data"
        submenuTitle="언론보도"
        breadcrumbMenu={menuData.label}
        breadcrumbLink={menuData.path}
    >
      {!isLoading && <ItemList items={sortedItems} order="/data/" />}
      {loadingError?.message && (
        <ErrorMessage>{loadingError.message}</ErrorMessage>
      )}
    </SubPage>
    </>
  );
}

export default DataPage;

/* Styled Components */

const ErrorMessage = styled.span`
  color: #e74c3c;
  font-size: 14px;
  display: block;
  margin-top: 20px;
`;
